import React, { Fragment, useEffect, useState } from 'react';
import { DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { Alert, Button, Divider, Form, Input, Switch, Upload } from 'antd';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { API_BASE_URL, ASSET_BASE_URL } from '../../../../configs/AppConfig';

export default {
    Renderer: (props) => {
        const data = props.data

        const [loaded, setLoaded] = useState(false)
        useEffect(() => {
            setLoaded(true)
        }, [])

        if (!loaded) {
            return null
        }

        const isMobile = props.device === "MOBILE"

        return (
            <div>
                <style>
                    {`
                        .rpv-core__inner-page{
                            background-color:transparent !important;
                        }
                    `}
                </style>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    {data.pdf && (
                        <Fragment>
                            {!data.previz && (
                                <Viewer fileUrl={data.pdf} />
                            )}

                            {data.previz && (
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "20px 0" }}>
                                    <div style={{ width: isMobile ? "100%" : "80%", height: "70vh" }}>
                                        <Viewer
                                            fileUrl={data.pdf}
                                            initialPage={0}
                                            scrollMode={"Page"}
                                            defaultScale={0.6}
                                        />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        <Button icon={<DownloadOutlined />} href={data.pdf} target={"_blank"}>
                                            <Trans>Télécharger le document</Trans>
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    )}

                    {!data.pdf && (
                        <Alert showIcon type={"warning"} message={t`Veuillez télécharger un fichier PDF.`} />
                    )}
                </Worker>
            </div>
        )

    },
    id: 'pdf-viewer',
    title: t`PDF`,
    description: t`Visionneuse de PDF`,
    icon: <FilePdfOutlined />,
    version: 1,
    controls: {
        type: 'custom',
        Component: Controls
    }
}

function Controls(props) {

    const { data, onChange } = props

    const [show, setShow] = useState(true)
    const refreshForm = () => {
        setShow(false)
        setTimeout(() => setShow(true), 100)
    }
    useEffect(() => {
        refreshForm()
    }, [props.lang, props.nodeId, props.device])

    if (!show) {
        return null
    }

    return (
        <div>
            <Upload.Dragger
                style={{ width: "100%" }}
                type={"select"}
                maxCount={1}
                multiple={false}
                accept="application/pdf"
                showUploadList={false}
                headers={{ authorization: localStorage.getItem("AUTH_TOKEN") }}
                action={API_BASE_URL + "/upload/doc?autoValide=1"}
                onChange={({ file }) => {
                    if (file.response && file.status === "done") {
                        const url = ASSET_BASE_URL + "/" + file.response
                        onChange({ pdf: url })
                    }
                }}
            >
                <p className="ant-upload-drag-icon">
                    <FilePdfOutlined />
                </p>
                <p className="ant-upload-text">
                    <Trans>Cliquez ou déposez votre fichier PDF</Trans>
                </p>
            </Upload.Dragger>

            <Divider><Trans>Ou</Trans></Divider>

            <Form.Item label={<Trans>Url</Trans>}>
                <Input placeholder={t`Url du PDF`} type="url" value={data.pdf}
                       onChange={(e) => onChange({ pdf: e.target.value })} />
            </Form.Item>

            <Form.Item label={<Trans>Afficher une prévisualisation</Trans>}>
                <Switch checked={data.previz}
                        onChange={(bool) => onChange({ previz: bool })} />
            </Form.Item>
        </div>
    )
}
